module.exports = __webpack_public_path__ + "img/flyer_03.231a474a.jpeg";